import { render, staticRenderFns } from "./DepositRowRegistration.vue?vue&type=template&id=b7b424bc&scoped=true&"
import script from "./DepositRowRegistration.vue?vue&type=script&lang=js&"
export * from "./DepositRowRegistration.vue?vue&type=script&lang=js&"
import style0 from "./DepositRowRegistration.vue?vue&type=style&index=0&id=b7b424bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b424bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTooltip})
